import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Const from '../../../Data/const';
import { action } from '../../../Data';
import { parseUrlParameter } from '../../../Lib/Utils';
import axios from 'axios';

// components

// styles

class WeiboRedirect extends Component{
    constructor(props){
        super(props);

        this.state = {
            modalVisible: true,
            loginType: '',
        }


        // 웨이보
        this.loadWeiboLoginApi = this.loadWeiboLoginApi.bind(this);
        this.href = '';

    }

    componentDidMount() {
        console.log('weibo page entered')
        if(this.props.onRef !== undefined) this.props.onRef(this);
        this.loadWeiboLoginApi();
    }

    loadWeiboLoginApi() {
        const loginParams = {};

        this.href = parseUrlParameter.parse(this.props.location.search).state || ''
        const params = {
            grant_type: 'authorization_code',
            client_id: Const.WEIBO.client_id,
            client_secret: Const.WEIBO.client_secret,
            code: parseUrlParameter.parse(this.props.location.search).code,
            redirect_uri: window.location.origin + window.location.pathname
        }

        this.href = this.href.substring(0, this.href.indexOf('?')) + (this.href.substring(this.href.indexOf('?'), this.href.length).replace(/,/gi, '&'))

        this.props.dispatch(action.eUSER.userWeiboLogin(params)).then((data) => {
            if (!data.result) {
                alert('login failed');
                return;
            }
            console.log(data);
            console.log(data);
            console.log(data);
            console.log(data, '----------------------------------------');
            this.props.dispatch(action.eUSER.login({ uid: 'weibo!' + data.result.uid, access_token: data.result.access_token })).then((response) => {
                if (!response.user) throw new Error('No User');
                Const.showAlert('', response.user.name + '님 ' + Const.LOGIN_SUCCESS_MESSAGE);
                localStorage.setItem(Const.TOKEN['user'], response.token);
                localStorage.setItem(Const.LOGIN_TIME['user'], new Date());
                let loginValue = null
                if (response.user.email) {
                    loginValue = response.user.email
                } else {
                    let uidTypeAndId = response.user.uid.split('!');

                    loginValue = uidTypeAndId[1];
                }
                Const.onLoginSuccess(response.token, loginValue);
                this.props.history.push(this.href);
            }).catch((err) => {
                console.log(err);
                alert(Const.MESSAGE_TABLE[this.props.COUNTRY_CODE].NOT_AUTHORIZED_ACCOUNT)
                //Const.showAlert('', Const.MESSAGE_TABLE[this.props.COUNTRY_CODE].NOT_AUTHORIZED_ACCOUNT);
                this.props.history.push(this.href);
            });
            // 로그인 시작, loginParams에 uid와 토큰이 담겨있습니다.
        });
    }

    render(){
        const { modalVisible } = this.state;
        if (!modalVisible) return null;

        return(
            <div>
            </div>
        )
    }
}

export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
    }
})(withRouter(WeiboRedirect))